<ng-template #template>
  <div
    class="card-spacing"
    [ngClass]="[
      'col-lg-' + width,
      needpaddingLeft ? 'pr-lg-0' : 'p-lg-0',
      isZoom ? 'zoomed' : ''
    ]"
  >
    <div class="card h-100" [ngClass]="{ 'card-comb-left': width === 8 }">
      <div class="card-body">
        <!--<h2>Region 1</h2>-->
        <h2>{{ data?.title }}</h2>
        <button
          type="button"
          (click)="zoom()"
          class="zoom"
          *ngIf="data.zoomInfo"
          [attr.aria-label]="'Zoom ' + data?.title"
          style="border: none; background: none; padding: 0;"
          ><img src="img/magnifier.svg" width="20px" class="zoom-chart"
          alt="" aria-hidden="true"
        /></button>
        <div style="display: block">
          <canvas
            baseChart
            [datasets]="lineChartData"
            [labels]="lineChartLabels"
            [options]="lineChartOptions"
            [colors]="lineChartColors"
            [legend]="lineChartLegend"
            [chartType]="lineChartType"
          >
          </canvas>
        </div>
      </div>
    </div>
  </div>
</ng-template>
